<script>
  /**
   * Breadcrumb navigation component for RFC and WFO links.
   *
   * @module Breadcrumb
   * @prop {string} wfo - Weather Forecast Office code.
   * @prop {Array<Object>} rfc - Array of RFC objects (each with a `name`).
   */

  export let wfo
  export let rfc
</script>

<div class="breadcrumb uk-margin-small uk-margin-bottom font-18 font-light">
  {#if rfc == null || rfc.length == 0}
    RFC Not Found...
  {:else if rfc.length == 1}
    <a href="/rfc/{rfc[0].name.toLowerCase()}" title={rfc[0].name}>{rfc[0].name.toUpperCase()}</a> /
    <a href="/wfo/{wfo.toUpperCase()}" title={wfo}>{wfo.toUpperCase()}</a>
  {:else}
    (
    {#each rfc as item, count}
      <a href="/rfc/{item.name.toLowerCase()}" title={item.name}>{item.name.toUpperCase()}</a
      >{#if count < rfc.length - 1},&nbsp;{/if}
    {/each}
    ) / <a href="/wfo/{wfo.toUpperCase()}" title={wfo}>{wfo}</a>
  {/if}
</div>

<style>
  .breadcrumb {
    margin-left: 25px;
  }
  .breadcrumb,
  .breadcrumb a {
    color: #024694;
  }
</style>
